import * as yup from "yup";

export const schema = yup.object().shape({
  email: yup
    .string()
    .email("Entered value does not match email format")
    .required("This field is required"),
});
